import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageType } from '@shared/definitions';
import { Subject } from 'rxjs';
import { FacebookAuthService } from '../facebook-auth.service';

@Component({
  selector: 'lib-dialog-pages-info',
  templateUrl: './dialog-pages-info.component.html',
  styleUrls: ['./dialog-pages-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogPagesInfoComponent implements OnInit {
  takeUntil$ = new Subject();
  shopId: string;

  constructor(
    public dialogRef: MatDialogRef<DialogPagesInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private facebookAuthService: FacebookAuthService
  ) {}

  ngOnInit(): void {
    if (this.data.shopId) {
      this.shopId = this.data.shopId;
    }
  }

  closeDialog(data?) {
    this.dialogRef.close(data);
  }

  pagesRedirect(pageType: string): void {
    this.facebookAuthService.pagesRedirect(this.shopId, pageType as PageType);
  }
}
